<template lang="pug">
  div#events
    v-card.imageTop(width="100%" height="400",dark)
      v-img(src="../assets/img/1x/gradient.png" height="100%"  )
        v-row(align="center" style="height:100%")
          v-col(cols="12" align="center")
            p.display-2.font-weight-black.events-title Upcoming Events
    router-view 
</template>

<script>
export default {};
</script>

<style lang="stylus" scoped>
.events-title
  font-family Cardo, 'san-serif' !important
</style>
